import { ArrowLeft, ArrowRight } from 'react-feather';
import { SidebarMenuItems } from './SidebarMenuItems';

interface SidebarMenuProps {
  onNavigate: () => void;
}

/** CUBA SidebarMenu — nav chrome + horizontal scroll arrows */
export function SidebarMenu({ onNavigate }: SidebarMenuProps) {
  return (
    <nav className="sidebar-main" id="sidebar-main">
      <div className="left-arrow d-none">
        <ArrowLeft />
      </div>
      <div id="sidebar-menu" style={{ margin: '0px' }}>
        <ul className="sidebar-links custom-scrollbar">
          <li className="back-btn">
            <div className="mobile-back text-end" onClick={onNavigate} role="button" tabIndex={0}>
              <span>Back</span>
              <i className="fa fa-angle-right ps-2" aria-hidden="true" />
            </div>
          </li>
          <SidebarMenuItems onNavigate={onNavigate} />
        </ul>
      </div>
      <div className="right-arrow">
        <ArrowRight />
      </div>
    </nav>
  );
}
